export interface IIma {
  // PCP / practice
  tin?: string | null;
  plan?: string | null;
  practice_name?: string | null;
  npi?: string | null;
  pcp_name?: string | null;
  pcp_address?: string | null;
  pcp_city?: string | null;
  pcp_state?: string | null;
  pcp_zip?: string | null;
  pcp_phone?: string | null;

  // Measure
  measure_code?: string | null;
  measure_description?: string | null;
  line_of_business?: string | null;

  // Member
  plan_member_id?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  date_of_birth?: string | null;
  language?: string | null;
  race_ethnicity?: string | null;
  gender?: string | null;
  member_address?: string | null;
  member_city?: string | null;
  member_state?: string | null;
  member_zip?: string | null;
  member_phone?: string | null;
  member_13th_birthday?: string | null;

  // IMA antigens
  ima_meningococcal_1?: string | null;
  ima_tdap_1?: string | null;
  ima_hpv_2?: string | null;

  // Reporting / metadata
  daterun?: string | null;
  filename?: string | null;
  added_tz?: string | null;
  file_date?: string | null;
  services_outstanding?: string | null;
  somos_member_id?: string | null;
  somos_provider_id?: string | null;
  service_location_id?: string | null;
  reporting_period?: string | null;
  owner_id?: number | null;
}

export class Ima implements IIma {
  tin?: string | null;
  plan?: string | null;
  practice_name?: string | null;
  npi?: string | null;
  pcp_name?: string | null;
  pcp_address?: string | null;
  pcp_city?: string | null;
  pcp_state?: string | null;
  pcp_zip?: string | null;
  pcp_phone?: string | null;

  measure_code?: string | null;
  measure_description?: string | null;
  line_of_business?: string | null;

  plan_member_id?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  date_of_birth?: string | null;
  language?: string | null;
  race_ethnicity?: string | null;
  gender?: string | null;
  member_address?: string | null;
  member_city?: string | null;
  member_state?: string | null;
  member_zip?: string | null;
  member_phone?: string | null;
  member_13th_birthday?: string | null;

  ima_meningococcal_1?: string | null;
  ima_tdap_1?: string | null;
  ima_hpv_2?: string | null;

  daterun?: string | null;
  filename?: string | null;
  added_tz?: string | null;
  file_date?: string | null;
  services_outstanding?: string | null;
  somos_member_id?: string | null;
  somos_provider_id?: string | null;
  service_location_id?: string | null;
  reporting_period?: string | null;
  owner_id?: number | null;

  constructor(data: IIma) {
    Object.assign(this, data);
  }

  static fromObject(data: IIma): Ima {
    return new Ima(data);
  }

  static fromObjectArray(data: IIma[]): Ima[] {
    return data.map(Ima.fromObject);
  }
}

export interface IResultIma {
  count: number;
  next: string | null;
  previous: string | null;
  results: IIma[];
}

export class ResultIma implements IResultIma {
  count: number = 0;
  next: string | null = null;
  previous: string | null = null;
  results: Ima[] = [];

  constructor(data?: IResultIma) {
    if (data) {
      this.count = data.count;
      this.next = data.next;
      this.previous = data.previous;
      this.results = data.results ? Ima.fromObjectArray(data.results) : [];
    }
  }

  static fromObject(data: IResultIma): ResultIma {
    return new ResultIma(data);
  }
}
